import React from "react";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";

const ButtonWrapper = ({ variant, disabled, onClick, color, size, startIcon, endIcon, label, background, type }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Button
        sx={{ borderRadius: "0.2vw", background: background || "" }}
        variant={variant}
        disabled={disabled}
        onClick={onClick}
        // color={color}
        size={size}
        startIcon={startIcon}
        endIcon={endIcon}
        type={type ? type : "button"}
      >
        {t(label)}
      </Button>
    </div>
  );
};

export default ButtonWrapper;
